export const HEADER_BANNER_HEIGHT = 40
